/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatRequest,
  ChatResponse,
  ConversationTitleRequest,
  ConversationTitleResponse,
  HTTPValidationError,
} from '../models/index';
import {
    ChatRequestFromJSON,
    ChatRequestToJSON,
    ChatResponseFromJSON,
    ChatResponseToJSON,
    ConversationTitleRequestFromJSON,
    ConversationTitleRequestToJSON,
    ConversationTitleResponseFromJSON,
    ConversationTitleResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface ChatApiV1ChatPostRequest {
    chatRequest: ChatRequest;
}

export interface GenerateChatTitleApiV1ChatTitlePostRequest {
    conversationTitleRequest: ConversationTitleRequest;
}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     * Send conversation history to the AI agent and get a response.  Args:     request: Chat request containing the conversation history     current_user: Authenticated user information     events: Event publisher dependency  Returns:     Chat response with the AI agent\'s answer  Raises:     HTTPException: If messages list is empty
     * Chat
     */
    async chatApiV1ChatPostRaw(requestParameters: ChatApiV1ChatPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatResponse>> {
        if (requestParameters['chatRequest'] == null) {
            throw new runtime.RequiredError(
                'chatRequest',
                'Required parameter "chatRequest" was null or undefined when calling chatApiV1ChatPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/chat/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatRequestToJSON(requestParameters['chatRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatResponseFromJSON(jsonValue));
    }

    /**
     * Send conversation history to the AI agent and get a response.  Args:     request: Chat request containing the conversation history     current_user: Authenticated user information     events: Event publisher dependency  Returns:     Chat response with the AI agent\'s answer  Raises:     HTTPException: If messages list is empty
     * Chat
     */
    async chatApiV1ChatPost(requestParameters: ChatApiV1ChatPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatResponse> {
        const response = await this.chatApiV1ChatPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a title for a chat conversation based on the first user message.  Args:     request: Title generation request containing the first user message     current_user: Authenticated user information     logger: Logger dependency     llm_model: LLM model dependency for title generation  Returns:     Generated title for the chat conversation  Raises:     HTTPException: If the first message is empty or title generation fails
     * Generate Chat Title
     */
    async generateChatTitleApiV1ChatTitlePostRaw(requestParameters: GenerateChatTitleApiV1ChatTitlePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConversationTitleResponse>> {
        if (requestParameters['conversationTitleRequest'] == null) {
            throw new runtime.RequiredError(
                'conversationTitleRequest',
                'Required parameter "conversationTitleRequest" was null or undefined when calling generateChatTitleApiV1ChatTitlePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/chat/title`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConversationTitleRequestToJSON(requestParameters['conversationTitleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationTitleResponseFromJSON(jsonValue));
    }

    /**
     * Generate a title for a chat conversation based on the first user message.  Args:     request: Title generation request containing the first user message     current_user: Authenticated user information     logger: Logger dependency     llm_model: LLM model dependency for title generation  Returns:     Generated title for the chat conversation  Raises:     HTTPException: If the first message is empty or title generation fails
     * Generate Chat Title
     */
    async generateChatTitleApiV1ChatTitlePost(requestParameters: GenerateChatTitleApiV1ChatTitlePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConversationTitleResponse> {
        const response = await this.generateChatTitleApiV1ChatTitlePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
